<template>
  <main class="maintenance-page">
    <section class="maintenance-hero" v-reveal>
      <div>
        <p class="section-kicker">{{ page.kicker }}</p>
        <h1>{{ page.title }}</h1>
        <p>{{ page.copy }}</p>
        <div class="hero-actions">
          <a class="action-button action-button--discord action-button--large" :href="page.primaryAction.href">
            <AppIcon :name="page.primaryAction.icon" />
            <span>{{ page.primaryAction.label }}</span>
          </a>
          <a class="action-button action-button--muted action-button--large" :href="page.secondaryAction.href">
            <AppIcon :name="page.secondaryAction.icon" />
            <span>{{ page.secondaryAction.label }}</span>
          </a>
        </div>
      </div>

      <PageMascotVisual />
    </section>
  </main>
</template>

<script>
import AppIcon from './AppIcon.vue'
import PageMascotVisual from './PageMascotVisual.vue'

export default {
  name: 'MaintenancePage',
  components: {
    AppIcon,
    PageMascotVisual
  },
  props: {
    page: {
      type: Object,
      required: true
    }
  }
}
</script>
